import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { MiscService } from '../../_service/misc.service';
import { DentalService } from '../../_service/dental.service';
import { SharedService } from '../../_service/shared.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-clinic-cases',
  templateUrl: './clinic-cases.component.html',
  styleUrls: ['./clinic-cases.component.css']
})
export class ClinicCasesComponent implements OnInit {
  treatList=[]; start_date:string='';end_date:string='';

  /***********Clinic Wise*********** */
  clinic_wise_sales_payment_loading:boolean=false;clinic_treatment='';performanceFieldSales = [];total_balance = 0;total_balance_payment=0;total_cash_count=0;total_cash_received=0;total_inside_sale=0;total_mtd_converted=0;total_mtd_revenue=0;total_mtd_sd=0;total_revenue_locked=0;

  constructor(private dentalapi:DentalService,private sharedapi:SharedService,public miscapi:MiscService) {}
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  ngOnInit(): void {
    this.getTreatmentCategory();
    this.getClinicWisePerformanceFieldSales();
  }

  async getTreatmentCategory()
  {
      await this.miscapi.getDentalTraetment().subscribe((data:any) => {
          if(data.status)
          {
              this.treatList = data.data;
          }else{
              this.treatList = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getClinicWisePerformanceFieldSales()
  {
    this.clinic_wise_sales_payment_loading=true;
    this.performanceFieldSales = [];
    this.total_balance = 0;
    this.total_balance_payment=0;
    this.total_cash_count=0;
    this.total_cash_received=0;
    this.total_inside_sale=0;
    this.total_mtd_converted=0;
    this.total_mtd_revenue=0;
    this.total_mtd_sd=0;
    this.total_revenue_locked=0;
    let qString = 'date_range='+this.start_date+'-'+this.end_date+'&treatment='+this.clinic_treatment;
    await this.dentalapi.getClinicWisePerformanceFieldSales(qString).subscribe((data:any) => {
        this.clinic_wise_sales_payment_loading=false;
        if(data.status)
        {
          this.performanceFieldSales = data.data;
          this.total_mtd_sd = this.performanceFieldSales.map(item => item.mtd_sd).reduce((prev, curr) => prev + curr, 0);
          this.total_mtd_converted = this.performanceFieldSales.map(item => item.mtd_converted).reduce((prev, curr) => prev + curr, 0);
          this.total_inside_sale = this.performanceFieldSales.map(item => item.inside_sale).reduce((prev, curr) => prev + curr, 0);
          this.total_revenue_locked = this.performanceFieldSales.map(item => Number(item.revenue_locked)).reduce((prev, curr) => prev + curr, 0);
          this.total_mtd_revenue = this.performanceFieldSales.map(item => Number(item.mtd_revenue)).reduce((prev, curr) => prev + curr, 0);
          this.total_cash_count = this.performanceFieldSales.map(item => Number(item.cash_count)).reduce((prev, curr) => prev + curr, 0);
          this.total_cash_received = this.performanceFieldSales.map(item => Number(item.cash_received)).reduce((prev, curr) => prev + curr, 0);
          this.total_balance_payment = this.performanceFieldSales.map(item => Number(item.balance_payment)).reduce((prev, curr) => prev + curr, 0);
          this.total_balance = this.total_balance_payment/this.total_revenue_locked;
        }else{
          this.performanceFieldSales = [];
          this.total_balance = 0;
          this.total_balance_payment=0;
          this.total_cash_count=0;
          this.total_cash_received=0;
          this.total_inside_sale=0;
          this.total_mtd_converted=0;
          this.total_mtd_revenue=0;
          this.total_mtd_sd=0;
          this.total_revenue_locked=0;
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  exportClinicWisePerformanceField()
  {
    if(this.performanceFieldSales.length>0)
    {
      let data = [];
      let titles = [
        'Clinic',
        'MTD SD',
        'MTD Converted',
        'Inside Sale',
        'Revenue Locked',
        'MTD Revenue',
        'Cash Count',
        'Cash Received',
        'Balance Payment',
        'Balance %'
      ];
      data.push(titles);
      for(let clinicSales in this.performanceFieldSales)
      {
        let exdata = [
          this.performanceFieldSales[clinicSales].name,
          this.performanceFieldSales[clinicSales].mtd_sd,
          this.performanceFieldSales[clinicSales].mtd_converted,
          this.performanceFieldSales[clinicSales].inside_sale,
          this.performanceFieldSales[clinicSales].revenue_locked,
          this.performanceFieldSales[clinicSales].mtd_revenue,
          this.performanceFieldSales[clinicSales].cash_count,
          this.performanceFieldSales[clinicSales].cash_received,
          this.performanceFieldSales[clinicSales].balance_payment,
          parseFloat(this.performanceFieldSales[clinicSales].balance).toFixed(2),
        ];
        data.push(exdata);
      }
      
      data.push(
        [
          'Total',
          this.total_mtd_sd,
          this.total_mtd_converted,
          this.total_inside_sale,
          this.total_revenue_locked,
          this.total_mtd_revenue,
          this.total_cash_count,
          this.total_cash_received,
          this.total_balance_payment,
          this.total_balance.toFixed(2)
        ]
      );
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
      XLSX.writeFile(wb, 'clinic_wise_performance_field_sales_'+utc+'.xlsx');
    }
    else
    {
      this.sharedapi.presentToast('No Data Found');
    }
  }

  dateRangeChangeclinic(date1,date2)
  {
    if(date2.value)
    {
      this.start_date = date1.value;
      this.end_date = date2.value;
      this.getClinicWisePerformanceFieldSales();
    }
  }

  clearDate(type)
  {
    if(type==1){
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.getClinicWisePerformanceFieldSales();
    }
  }
}
